import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchFeatureInfoThunk = createAsyncThunk(
  "gis/fetchFeatureInfo",
  async (url: string, { rejectWithValue }) => {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch feature info");
    }
  }
);